import {css} from '@yandex-delivery/blocks/theme/css'

export const trail = css`
  width: auto;
`
